import React from 'react'
import './style.css'
import Button from '../CtaButton'
import ServicesBannerForm from '../services-banner-from/ServicesBannerForm'

const SecondCtaBox = ({ content }) => {
    return (
        <>
            {/* <section className="case-study-cta">
                <div className="container">
                    <div className="row align-items-center position-relative">
                        <div className="col-md-8">
                            <h2 className='second-cta-heading' dangerouslySetInnerHTML={{
                                __html: content?.heading,
                            }}></h2>
                        </div>
                        <div className="col-md-4">
                            <ServicesBannerForm />
                        </div>
                    </div>
                </div>
            </section> */}
            <section
                className="case-study-cta"
                style={{
                    backgroundImage: `url(${content?.ctaImage || "/images/second-cta-bg.jpg"})`,
                }}
            >
                <div className="container">
                    <div className="row align-items-center position-relative">
                        <div className="col-md-8">
                            <h2
                                className="second-cta-heading"
                                dangerouslySetInnerHTML={{ __html: content?.heading }}
                            ></h2>
                            {/* <Button text={content?.cta?.text} link={content?.cta?.link} /> */}
                        </div>
                        <div className="col-md-4">
                            <ServicesBannerForm />
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default SecondCtaBox